import React from 'react';
import PropTypes from 'prop-types';
import { texts } from 'utils/languages/fr';

import CustomDialogTitle from 'components/CustomDialogTitle/CustomDialogTitle';
import { Dialog, DialogContent } from '@mui/material';
import { ucFirst } from 'utils/helpers';

const ContactDialog = ({ open, onCancel }) => (
    <Dialog open={open}>
        <CustomDialogTitle handleClose={onCancel} title={ucFirst(texts.CONTACT).replace('.', '')} />
        <DialogContent></DialogContent>
    </Dialog>
);

ContactDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ContactDialog;
